export default __webpack_public_path__ + "static/media/36.0a6804d9.png";